import { render, staticRenderFns } from "./footerWorkflowTool.vue?vue&type=template&id=6361f15f&scoped=true&"
import script from "./footerWorkflowTool.vue?vue&type=script&lang=js&"
export * from "./footerWorkflowTool.vue?vue&type=script&lang=js&"
import style0 from "./footerWorkflowTool.vue?vue&type=style&index=0&id=6361f15f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361f15f",
  null
  
)

export default component.exports